<template lang="pug">
	.download-button
		.icon(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Download creative'}" v-pseudo-modal-show="'download-dropdown'" v-on:click="$root.$emit('bv::hide::tooltip')")
			.fa.fa-download
		.dropdown-menu.dropdown-menu-right(v-pseudo-modal="'download-dropdown'" :class="{'multiple-download': Project.SelectedProject.type === 'playable' && multipleDownloadAllowed}")
			.dropdown-header
				strong Download creative
				span.multiple-download-switch(v-if="isShowMultipleDownload()" v-b-tooltip.hover="{title: 'Enable multiple download'}")
					.switch-control
						label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
							input.switch-input.form-check-input(type="checkbox" v-model="multipleDownloadAllowed" @change.stop="User.toggleFeature(User.currentUser.id, 'multipleDownload', multipleDownloadAllowed)")
							span.switch-slider(data-checked="On" data-unchecked="Off")
							span.switch-handle
			NetworkList(:callback="downloadCreative" scope="download" :multipleAllowed="multipleDownloadAllowed")
			.multiple-download-button-wrapper
				button.btn.btn-success.multiple-download-button(v-on:click="downloadCreativesMultiple" :class="{'disabled': User.currentUser && User.currentUser.options.features && Object.keys(User.currentUser.options.features.multipleDownloadNetworks || {}).length < 1}") Download

</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Project } 			from '../../services/Project'
	import { User }				from '../../services/User'
	import { Server } 			from "../../services/Server"
	import { Version } 			from "../../services/Version"

	import NetworkList 			from './../Templates/NetworksList'

	export default {
		name: "DownloadButton",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Changed", "Multiple Download Networks Changed"],
		},
		components: {
			NetworkList
		},
		data() {

			this.Project = Project;
			this.User = User;

			return {
				showed: true,
				multipleDownloadAllowed: false
			};

		},
		methods: {
			collectData() {
				this.multipleDownloadAllowed = false;
				if (User.currentUser && User.currentUser.options && User.currentUser.options.features)
					this.multipleDownloadAllowed = User.currentUser?.options?.features?.multipleDownload && this.isShowMultipleDownload();

			},
			downloadCreative(type) {

				if (Monitoring.activeProcesses['release-build'][`${Version.SelectedVersion.id}-${type}`]) return;

				if (type === 'sky-kids') {

					Broadcast.call("Show UploadSkyKids", ["download-mode"]);

				} else {

					Project.downloadCreative(type);

				}

				Broadcast.call("Download Creative Started");

			},
			downloadCreativesMultiple() {

				if (User.currentUser && User.currentUser.options && User.currentUser.options.features) {
					let networks = Object.keys(User.currentUser.options?.features?.multipleDownloadNetworks || {}).filter(release => Settings.isReleaseAvailable(release, this.multipleDownloadAllowed, 'download'));
					if (networks.length < 1) return;

					Server.sendToSocket({
						DownloadCreativeMultiple: {
							projectId: Project.SelectedProject.id,
							versionId: Version.SelectedVersion.id,
							releasesTypes: networks
						}
					});

					networks.forEach(network => {
						Monitoring.setProcess({type: "release-build", name: `${Version.SelectedVersion.id}-${network}`})
					});

				}
			},
			isShowMultipleDownload() {

				let show = true;

				if (Project.SelectedProject.type !== 'playable') show = false;

				if (Publisher.SelectedPublisher && Publisher.SelectedPublisher.options) {

					let releaseNames = Publisher.SelectedPublisher.options.ReleaseNames;

					if (releaseNames === 'version-names-only' || releaseNames === 'use-title') show = false;

				}

				return show;

			}
		}
	}
</script>


<style lang="sass">

	.download-button
		list-style: none
		position: relative

		.dropdown-menu
			position: absolute
			right: -40px
			top: 40px
			z-index: 10000
			line-height: 1.5
			width: 300px
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)
			display: flex
			flex-direction: column

			.dropdown-header
				cursor: default
				display: flex
				flex-direction: row
				justify-content: space-between

				>strong
					padding-left: 0

				.multiple-download-switch
					opacity: 0.3

				strong:only-child
					margin: 0 auto

			.networks
				height: 500px
				overflow-x: hidden
				overflow-y: auto

				.dropdown-item
					white-space: normal
					padding: 0px 20px 10px 20px
					width: 300px

			.networks::-webkit-scrollbar
				width: 10px
				margin-left: -10px
				-webkit-appearance: none
				appearance: none

			.networks::-webkit-scrollbar-track
				background-color: rgba(255,255,255,0.3)
				border-right: 1px solid #f2f2f2
				border-left: 1px solid #f2f2f2

			.networks::-webkit-scrollbar-thumb
				height: 50px
				background-color: rgba(255,255,255,0.2)
				background-clip: content-box
				border-color: transparent
				border-style: solid
				border-width: 1px 2px

			.multiple-download-button-wrapper
				display: none
				position: relative
				background-color: #353b41
				border-top: 1px solid #23282c
				height: 45px
				justify-content: center
				cursor: none
				pointer-events: none

				button
					border-color: #548364
					border-radius: 50px
					width: 50%
					height: 35px
					margin-top: 5px
					margin-bottom: 5px
					opacity: 0
					pointer-events: none
					cursor: none

			&.multiple-download
				width: 330px

				.dropdown-header
					>strong
						padding-left: 30px

				.multiple-download-switch
					opacity: 1

				.networks
					.dropdown-item
						padding: 0 20px 10px 50px
						width: 330px

				.multiple-download-button-wrapper
					display: flex

					button
						opacity: 1
						pointer-events: auto
						cursor: pointer

						&.disabled
							opacity: 0.3
							cursor: not-allowed


</style>

